import { render, staticRenderFns } from "./BoletoTimeline.vue?vue&type=template&id=b31e8662&"
import script from "./BoletoTimeline.vue?vue&type=script&lang=js&"
export * from "./BoletoTimeline.vue?vue&type=script&lang=js&"
import style0 from "./BoletoTimeline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports